"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallInlineFadeInSpinner = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var fadeInAnimation = data_catalog_shared_1.keyframes({
    '0%': { opacity: 0 },
    '100%': { opacity: 1 }
});
var SpinnerContainer = data_catalog_shared_1.divWithStyle('SpinnerContainer', {
    position: 'relative',
    paddingLeft: widgets_1.TabStyles.Spacing.DefaultSpace,
    animationName: fadeInAnimation,
    animationDuration: '500ms',
    animationTimingFunction: 'ease-in',
    height: widgets_1.ActivitySpinnerSize.Small // ensures the div doesn't change size due to rotation of spinner
});
function SmallInlineFadeInSpinner() {
    return (React.createElement(SpinnerContainer, null,
        React.createElement(widgets_1.ActivitySpinnerWidget, { spinnerSize: widgets_1.ActivitySpinnerSize.Small, testId: '' })));
}
exports.SmallInlineFadeInSpinner = SmallInlineFadeInSpinner;
//# sourceMappingURL=SmallInlineFadeInSpinner.js.map